import Vue from 'vue'
import httpManager from '../../util/common'
let vm = {
  delimiters: ['{', '}'],
  model: {    // 使用model， 这儿2个属性，prop属性说，我要将msg作为该组件被使用时（此处为aa组件被父组件调用）v-model能取到的值，event说，我emit ‘cc’ 的时候，参数的值就是父组件v-model收到的值。
      prop: 'parentProp',
      event: 'parentEvent'
    },
  props: {
    parentProp:String,
    disabled:Boolean
  },
  data: () => {
    return {
      company_name: '',
      entity: null,
      hints: [],
      showHintsBox: false,
      activeNo: -1,
      closeClick: false,
      check_company_name: '',
    }
  },
  computed: {

  },
  methods: {

    getEntity () {
      let self = this
      let params = new Map()
      if(!self.check_company_name){
        self.$emit('parentEvent', null)
        return
      }
      params.set('keyword', self.check_company_name)
      // console.log(self.check_company_name);
      // this.$emit('getCompanyName',self.check_company_name)
      httpManager('entity_search', params)
        .then(response => {
          if(response.data && response.data[0])
            self.$emit('parentEvent', response.data[0].oa_id)
          else
            self.$emit('parentEvent', self.check_company_name)
        })
        .catch(error => {
          this.$emit('input', self.check_company_name)
          console.log(error)
        })
    },
    clear() {
      this.company_name = ''
    },
    companyComplete () {
      let self = this
      let params = new Map()
      params.set('keyword', self.company_name)
      httpManager('entity_fix', params)
        .then(response => {
          self.hints = response.data.map(x => x.full_short_ent_ticker)
          self.showHintsBox = true
        })
        .catch(error => {
          console.log(error)
        })
    },
    fillInput: function (index) {
      this.showHintsBox = false
      this.closeClick = true
      let value = this.hints[index]
      this.hints = []
      this.company_name = value
      this.check_company_name = this.company_name
    },
    closeHintsBox: function () {
      let self = this
      setTimeout(function () {
        self.showHintsBox = false
        self.hints = []
      }, 250)
    }
  },
  mounted () {
  },
  watch: {
    check_company_name: function () {
      if(!this.company_name){
          this.$emit('parentEvent', null)
      }else{
        this.getEntity()
      }
    },
    company_name: function () {
      if (!this.closeClick) {
        if (this.company_name === '') {
          this.closeHintsBox()
          this.$emit('parentEvent', null)
          return
        }
        let last = this.company_name
        setTimeout(()=>{
          if(last === this.company_name){
            this.companyComplete()
          }
        },500)
      } else {
        this.closeClick = false
      }
      if(!this.company_name){
        this.check_company_name = null
      }

    },
  }
}
Vue.component('company-search', vm)
export default vm



// WEBPACK FOOTER //
// ./src/home/js/company_search.js